// Extracted from shared/appearance.ts; behavior and declaration bodies preserved.
import type { DomainObject } from "../shared/contracts.js";
/** Prefer an explicit selection; a surrogate is not automatically the primary key. */
export function selectedPrimaryKeys(keys: DomainObject[]): DomainObject[] {
  const candidates = keys.filter(key => key.kind === 'key');
  const selected = candidates.filter(key => key.selectedPrimary === true);
  if (selected.length) return selected.length === 1 ? selected : [];
  const primary = candidates.filter(key => key.keyRole === 'primary' && key.selectedPrimary !== false);
  return primary.length === 1 ? primary : [];
}
